<template>
    <div>
        <b-modal centered id="selectCarrier" ref="selectCarrier" hide-footer title="Select Carrier">

            <div class="select-carrier-box">
                <div @click="selectCarrier(1)" class="carrier-option">
                    <label for="simon-carrier">
                        <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                        <img src="../../assets/img/simon-carrier-dark.svg" alt="" class="dark-mode">
                    </label>
                </div>
                <div @click="selectCarrier(2)" class="carrier-option">
                    <label for="t-mobile-carrier">
                        <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                        <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-mode">
                    </label>
                </div>
            </div>
        </b-modal>
        <b-modal centered id="bulk-modal" ref="bulk-modal" size="xl" @hidden="unselectAllRowModal()" hide-footer title="Bulk Operations">
            <nav class="select-actions">
                <b-button variant="link" :class="[(this.selectedActions == true) ? 'active' : '' ]" @click="selectActionsModal()">Actions</b-button>
                <b-button variant="link" :class="[(this.selectedChangePlan == true) ? 'active' : '' ]" @click="selectPlanModal()">Plan Change</b-button>
                <b-button variant="link" :class="[(this.selectedSimSwap == true) ? 'active' : '' ]" @click="selectSwapModal()">Sim Swap</b-button>
            </nav>

            <div class="dnd-area">
                <div class="image">
                    <img src="../../assets/img/upload-sims.png" alt="">
                </div>
                <div class="text">
                    <h3>Drag and drop list of SIM's or Browse</h3>
                    <h4>The file selected needs to be a CSV file where the SIMs are seperated by commas.</h4>
                </div>
                <div class="label">
                    <input type="file" id="file-bulk-modal" v-on:change="readSimFileModal">
                    <label for="file-bulk-modal" class="btn btn-primary">Browse</label>
                </div>
            </div>

            <div v-if="selectedChangePlan" class="migrate-plan">
                <h3>Plan you want to migrate from</h3>
                <div class="migrate-from">
                    <div v-if="selectedPlanFrom.iccid == 0" class="inner-migrate">
                        <b-button variant="primary" @click="selectFromPlan()">Select Plan</b-button>
                        <p>Select a Plan you want to migrate your SIMs from </p>

                        <label>
                            <input type="checkbox" name="selectAllSims" v-model="selectAllSimsRatePlan">
                            <span>Automaticly select all SIMs with the choosen plan</span>
                        </label>
                    </div>
                    <div v-else-if="selectedPlanFrom.carrierId == 1" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedFrom.name}}</h3>

                                <div class="category">
                                    <h4>{{ratePlanSelectedFrom.category}}</h4>

                                    <em>{{ratePlanSelectedFrom.dataLimit}}</em>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Plan</b-button>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanFrom.carrierId == 1" class="right-col list-options">
                                <!-- <div :class="['item-options',  ratePlanSelectedFrom.planOptions.dataPooling == 'ON' ? 'true' : 'false']">
                                    <span>Pooling</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.dataPooling == 'ON'">ON</em> <em v-else>OFF</em>
                                </div> -->

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.hasRoaming == 'ON' ? 'true' : 'false']">
                                    <span>Tier 1 International Roaming</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.hasRoaming == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.roaming2 == 'ON' ? 'true' : 'false']">
                                    <span>Tier 2 International Roaming</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.roaming2 == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.sms == 'ON' ? 'true' : 'false']">
                                    <span>SMS</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.sms == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasThrottle != 0 ? 'true' : 'false']">
                                    <span>Throttle {{ratePlanSelectedFrom.dataGuard.throttleAt}} {{ratePlanSelectedFrom.dataGuard.throttleAtUnit}}</span>
                                    <em v-if="ratePlanSelectedFrom.dataGuard.hasThrottle == true">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.dataGuard.hasCap != 0 ? 'true' : 'false']">
                                    <span>Cap {{ratePlanSelectedFrom.dataGuard.capAt}} {{ratePlanSelectedFrom.dataGuard.capAtUnit}}</span>
                                    <em v-if="ratePlanSelectedFrom.dataGuard.hasCap != 0">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedFrom.planOptions.staticIp == 'ON' ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedFrom.planOptions.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                                {{ratePlanSelectedFrom.description}}
                            </div>
                    </div>
                    <div v-else-if="ratePlanSelectedFrom.carrierId == 2" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedFrom.planName}}</h3>

                                <div class="category magenta">
                                    <h4>Magenta</h4>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Plan</b-button>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanFrom.carrierId == 2" class="right-col list-options">
                                <div :class="['item-options',  ratePlanSelectedFrom.staticIp ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedFrom.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                            {{ratePlanSelectedFrom.planDescription}}
                        </div>
                    </div>
                </div>

                <div class="migrate-to">
                    <div v-if="selectedPlanTo.iccid == 0" class="inner-migrate">
                        <b-button variant="primary" @click="selectToPlan()">Select Plan</b-button>
                        <p>Select a Plan you want to migrate your SIMs to </p>
                    </div>
                    <div v-else-if="selectedPlanTo.carrierId == 1" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedTo.name}}</h3>

                                <div class="category">
                                    <h4>{{ratePlanSelectedTo.category}}</h4>

                                    <em>{{ratePlanSelectedTo.dataLimit}}</em>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectToPlan()">Select Plan</b-button>
                            </div>
                        </div>
                        <div class="body-plan">
                            <div v-if="selectedPlanTo.carrierId == 1" class="right-col list-options">
                                <!-- <div :class="['item-options',  ratePlanSelectedTo.planOptions.dataPooling == 'ON' ? 'true' : 'false']">
                                    <span>Pooling</span>
                                    <em v-if="ratePlanSelectedTo.planOptions.dataPooling == 'ON'">ON</em> <em v-else>OFF</em>
                                </div> -->

                                <div :class="['item-options',  ratePlanSelectedTo.planOptions.hasRoaming == 'ON' ? 'true' : 'false']">
                                    <span>Tier 1 International Roaming</span>
                                    <em v-if="ratePlanSelectedTo.planOptions.hasRoaming == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedTo.planOptions.roaming2 == 'ON' ? 'true' : 'false']">
                                    <span>Tier 2 International Roaming</span>
                                    <em v-if="ratePlanSelectedTo.planOptions.roaming2 == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedTo.planOptions.sms == 'ON' ? 'true' : 'false']">
                                    <span>SMS</span>
                                    <em v-if="ratePlanSelectedTo.planOptions.sms == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedTo.dataGuard.hasThrottle != 0 ? 'true' : 'false']">
                                    <span>Throttle {{ratePlanSelectedTo.dataGuard.throttleAt}} {{ratePlanSelectedTo.dataGuard.throttleAtUnit}}</span>
                                    <em v-if="ratePlanSelectedTo.dataGuard.hasThrottle == true">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedTo.dataGuard.hasCap != 0 ? 'true' : 'false']">
                                    <span>Cap {{ratePlanSelectedTo.dataGuard.capAt}} {{ratePlanSelectedTo.dataGuard.capAtUnit}}</span>
                                    <em v-if="ratePlanSelectedTo.dataGuard.hasCap != 0">ON</em> <em v-else>OFF</em>
                                </div>

                                <div :class="['item-options',  ratePlanSelectedTo.planOptions.staticIp == 'ON' ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedTo.planOptions.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                                {{ratePlanSelectedTo.description}}
                            </div>
                    </div>
                    <div v-else-if="ratePlanSelectedTo.carrierId == 2" class="inner-migrate">
                        <div class="header-plan">
                            <div class="title">
                                <h3>{{ratePlanSelectedTo.planName}}</h3>

                                <div class="category magenta">
                                    <h4>Magenta</h4>
                                </div>
                            </div>

                            <div class="button">
                                <b-button variant="primary" @click="selectFromPlan()">Select Plan</b-button>
                            </div>
                        </div>

                        <div class="body-plan">
                            <div v-if="selectedPlanTo.carrierId == 2" class="right-col list-options">
                                <div :class="['item-options',  ratePlanSelectedTo.staticIp ? 'true' : 'false']">
                                    <span>Static IP</span>
                                    <em v-if="ratePlanSelectedTo.staticIp == 'ON'">ON</em> <em v-else>OFF</em>
                                </div>
                            </div>
                        </div>
                        <div class="plan-description">
                            {{ratePlanSelectedTo.planDescription}}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="simSwapStep2 == false" class="sims-list-wrapper fts-table-wrapper">
                <div v-if="selectedSimSwap == true" class="sim-swap-header">
                    <strong>Select SIM cards that will be swapped. </strong>
                    <p>After selecting SIM cards or drag and drop a list of  SIMs press next to select cold stock SIMs</p>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <b-form-group class="mb-0">
                            <b-input-group>
                                <input type="text" class="form-control" v-model="filterModal" v-on:keyup="searchKeyUpModal" v-on:keydown="searchKeyDownModal" placeholder="Search">
                            </b-input-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 text-right management-list-control">
                    </div>
                    <div class="col-md-2 text-right">
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePageModal" v-model="sortSettingsModal.size" id="size-page" class="form-control">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="mb-0 table-outline table-responsive-sm table-sims fts-table">
                    <table v-if='simsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment">
                        <thead role="rowgroup">
                            <tr role="row" :aria-selected="selectedAllModal">
                                <th role="columnheader" v-on:click="selectAllRowsModal()" class="small-coll" aria-colindex="0" aria-label="Checkbox"><span class="fts-checkbox"></span></th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="1" aria-label="Sim" aria-sort="none">SIM</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="2" aria-label="Phone" aria-sort="none">MSISDN</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="3" aria-label="Status" aria-sort="none">Status</th>
                                <th v-if="custom1" v-on:click="changesSortModal" role="columnheader" aria-colindex="4" :aria-label="custom1" aria-sort="none">{{custom1}}</th>
                                <th v-if="custom2" v-on:click="changesSortModal" role="columnheader" aria-colindex="5" :aria-label="custom2" aria-sort="none">{{custom2}}</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="6" aria-label="Carrier" aria-sort="none">Carrier</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="7" aria-label="Last Active" aria-sort="none">Last Active</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="8" aria-label="In transaction" aria-sort="none">In transaction</th>
                                <th v-on:click="changesSortModal" role="columnheader" aria-colindex="9" aria-label="Plan" aria-sort="none">Plan</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in simsList" :data-iccid="item.iccid" v-bind:key="index" :aria-selected="isSelected(item.iccid)">
                                <td v-on:click="selectRowModal(item.iccid, item.status)" role="cell" aria-colindex="1" class="small-coll"><span class="fts-checkbox"></span></td>
                                <td>{{item.iccid}}</td>
                                <td>{{item.msisdn}}</td>
                                <td>{{item.status}}</td>
                                <td><span v-if="item.customFields && item.customField1">{{item.customField1}}</span><span v-else>-</span></td>
                                <td v-if="custom2"><span v-if="item.customFields && item.customField2">{{item.customField2}}</span><span v-else>-</span></td>
                                <td>
                                    <span v-if="item.carrierId && item.carrierId == 1">SimonIoT</span>
                                    <span v-else-if="item.carrierId && item.carrierId == 2">T-Mobile</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="item.lastActiveOn">{{item.lastActiveOn}}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="item.pendingAction">{{item.pendingAction}}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>{{item.ratePlanName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="bottom-table">
                    <div class="selected-sim">
                        SIMs selected: {{selectedRowsModal.length}}
                    </div>
                    <nav v-if="paginationCountModal" aria-label="Page navigation example">
                        <paginate :page-count="paginationCountModal" v-model="sortSettingsModal.page" :click-handler="paginationControllModal" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                    </nav>

                    <div class="button-wrapper">
                        <b-button v-if="selectedActions == true" class="restore" variant="success" v-on:click="actionSim('restore')">Restore</b-button>
                        <b-button v-if="selectedActions == true" class="suspend"  variant="danger" v-on:click="actionSim('suspend')">Suspend</b-button>
                        <b-button v-if="selectedActions == true && selectedCarrrier == 1" class="deactive-button" variant="danger" @click="actionSim('deactive')">Deactivate</b-button>
                        <b-button v-if="selectedActions == true && selectedCarrrier == 1" class="reset-button" variant="danger" v-b-tooltip.hover title="This will force device reconenection to network" v-on:click="actionSim('reset')">Reset SIM Connection</b-button>
                        <b-button class="cancel" variant="light" v-on:click="closeModal()">Cancel</b-button>
                        <b-button v-if="selectedChangePlan == true" @click="changeRatePlan()" class="migrate" variant="success" :disabled="(this.selectedPlanTo.iccid == 0 || this.selectedPlanFrom.iccid == 0)">Migrate</b-button>
                        <b-button v-if="selectedSimSwap == true" @click="goToSwapSim()" :disabled="this.selectedRowsModal.length == 0" class="next" variant="success">Next</b-button>
                        <b-button v-if="simSwapStep2 == true" variant="success" :disabled="(this.selectedColdStockArr.length == 0)" @click="swapColdSims()">Swap</b-button>
                    </div>

                    <div class="loader-sim-list" v-if="loadingSimListModal && noSimsModal == false">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>
                    </div>

                    <div class="no-sims" v-if="loadingSimListModal == false && noSimsModal == true">
                        <h2 class="text">You have no SIMs</h2>
                    </div>
                </div>
            </div>

            <div v-if="simSwapStep2 == true" class="cold-stock-list-wrapper">
                <div class="cold-sims-list">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group class="mb-0">
                                <b-input-group>
                                    <input type="text" class="form-control" v-model="filterColdStock" v-on:keyup="searchKeyUpColdStock" v-on:keydown="searchKeyDownColdStock" placeholder="Search">
                                </b-input-group>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 text-right">
                            <div class="select-control">
                            </div>
                            <div class="export-control">

                            </div>
                        </div>
                        <div class="col-md-2 text-right">
                            <label for="size-page">Display:</label>
                            <select v-on:change="sizePageColdStock" v-model="sortSettingsColdStock.size" id="size-page" class="form-control">
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-0 table-outline table-responsive-sm table-cold-stock table-coldstock">
                        <table  v-if='coldStockList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                            <thead role="rowgroup">
                                <tr role="row" :aria-selected="selectedAllColdStock">
                                    <th v-on:click="selectAllRowsColdStock" role="columnheader" class="small-coll" aria-colindex="0" aria-label="Checkbox">
                                        <span class="fts-checkbox"></span>
                                    </th>
                                    <th role="columnheader" aria-colindex="1" aria-label="SIM">SIM</th>
                                    <th role="columnheader" aria-colindex="2" aria-label="Carrier">Carrier</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in coldStockList" :data-iccid="item.iccid" :aria-selected="isSelectedColdStock(item.iccid)" v-bind:key="index">
                                    <td v-on:click="selectRowColdStock(item.iccid)" role="cell" aria-colindex="1" class="small-coll"><span class="fts-checkbox"></span></td>
                                    <td>{{item.iccid}}</td>
                                    <td>
                                        <span v-if="item.carrierId == 1">SimonIoT</span>
                                        <span v-else-if="item.carrierId == 2">T-Mobile</span>
                                        <span v-else-if="item.carrierId == 3">Vodafone</span>
                                        <span v-else>--</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="bottom-table">
                        <div class="loader-sim-list" v-if="loadingColdSims == true && noColdStock == false">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                        </div>

                        <div class="no-sims" v-if="loadingColdSims == false && noColdStock == true">
                            <h2 class="text">You have no Cold SIMs</h2>
                        </div>

                        <div class="selected-sim">
                            SIMs selected: {{selectedColdStockArr.length}}
                        </div>
                        <nav v-if="paginationCountColdStock" aria-label="Page navigation example">
                            <paginate :page-count="paginationCountColdStock" :click-handler="paginationControllColdStock" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                        </nav>

                        <div class="button-wrapper">
                            <b-button v-if="selectedActions == true" class="restore" variant="success" v-on:click="actionSim('restore')">Restore</b-button>
                            <b-button v-if="selectedActions == true" class="suspend"  variant="danger" v-on:click="actionSim('suspend')">Suspend</b-button>
                            <b-button v-if="selectedActions == true" class="reset-button" variant="danger" v-b-tooltip.hover title="This will force device reconenection to network" v-on:click="actionSim('reset')">Reset</b-button>
                            <b-button class="cancel" variant="light" v-on:click="closeModal()">Cancel</b-button>
                            <b-button v-if="selectedChangePlan == true" @click="changeRatePlan()" class="migrate" variant="success" :disabled="(this.selectedPlanTo.iccid == 0 || this.selectedPlanFrom.iccid == 0)">Migrate</b-button>
                            <b-button v-if="selectedSimSwap == true && simSwapStep2 == false" @click="goToSwapSim()" :disabled="this.selectedRowsModal.length == 0" class="next" variant="success">Next</b-button>
                            <b-button v-if="simSwapStep2 == true" variant="success" :disabled="(this.selectedColdStockArr.length == 0)" @click="swapColdSims()">Swap</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal centered id="select-from-plan" ref="select-from-plan" size="xl" title="Bulk Operations - Plan change" hide-footer>
            <div class="modal-header">
                <div class="rate-plan-name">Select Plan that you want to Migrate from</div>
                <div class="filters-plan">
                    <strong>Filter: </strong>
                    <span v-on:click="showAllFrom" class="active">All</span>
                    <span v-on:click="showFlexFrom">Flex</span>
                    <span v-on:click="showHighbandwidthFrom">High Bandwidth</span>
                    <span @click="showSimonPlansFrom">Simon Plans</span>
                    <span @click="showTmobilePlansFrom">T-Mobile Plans</span>
                </div>
            </div>
            <div class="modal-content">
                <div v-if="templateLists.length > 0 && !loading" class="templates-wrap" id="templates-wrap">
                    <div v-if="selectedCarrrier != 2" class="simon-plans">
                        <div v-for="(templateItem, index) in templateLists" :key="templateItem.id" :id="'template-' + templateItem.id"
                             :class="[
                                 'template-item',
                                 templateItem.categoryClass,
                                 (templateItem.active == 1) ? 'plan-active' : 'plan-inactive',
                                 (templateItem.categoryClass != 'flex' && selectedPlans == 3) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'highbandwidth' && selectedPlans == 4) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'nb-iot' && selectedPlans == 5) ? 'plan-hidden' : ''
                                 ]" @click="selectPlanFrom(templateItem.id, 1)">
                            <div class="inner-template">
                                <div class="carrier-logo simon">
                                    <img src="../../assets/img/darklogo.svg" alt="">

                                    <div class="controls">
                                        <a class="deactivate" v-on:click="confirmdelete(index, templateItem.id, templateItem.name)">Deactivate</a>
                                        <div class="tooltip-on-hover">
                                            <h3>Deactivate Rate Plan</h3>
                                            <p>Selecting This Will Disable This Rate Plan from Future Use</p>
                                            <p>Note: It Wont Affect SIMs Currently on this Plan</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.name }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <span class="name">{{ templateItem.category }}</span>
                                            <span class="value">{{ templateItem.dataLimit }}</span>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">International Roaming</span>
                                                <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Data Pooling</span>
                                                <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Throttle</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>

                                            <div class="option">
                                                <span class="name">Cap</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt && templateItem.dataGuard.capAtUnit">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.usageAlert && templateItem.usageAlert.limit > 0">{{templateItem.usageAlert.limit}} {{templateItem.usageAlert.unit}}</span>
                                                    <span class="value" v-if="templateItem.usageAlert && templateItem.usageAlert.limit > 0">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="down">
                                            <div class="description">
                                                <span class="name">Plan Description</span>
                                                <span class="value">{{templateItem.description}}</span>
                                            </div>

                                            <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                <div class="start-price">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div class="static-ip">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false" class="discount">
                                                    <span>Discount</span>
                                                    <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 2 || selectedCarrrier == 0" class="tmobile-plans plans-list">
                        <div v-for="(templateItem, index) in ratePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'flex']" @click="selectPlanFrom(templateItem.ratePlanId, 2)">
                            <div class="inner-template">
                                <div class="carrier-logo tmobile">
                                    <img src="../../assets/img/magenta-logo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.category }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>

                                        <div class="price">
                                            <span class="name">Cost Per Line</span>
                                            <span v-if="templateItem.customUnitPrice" class="value">{{templateItem.customUnitPrice}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="templates-wrap no-templates text-center">
                    <p>No plans have been made. Click here to here make a plan. </p>
                    <button class="btn btn-success" v-on:click="goToCreatePlan"><i class="fa fa-plus"></i>Add New Plan</button>
                </div>
            </div>
        </b-modal>
        <b-modal centered id="select-to-plan" ref="select-to-plan" size="xl" title="Bulk Operations - Plan change">
            <div class="modal-header">
                <div class="rate-plan-name">Select Plan that you want to Migrate to</div>
                <div class="filters-plan">
                    <strong>Filter: </strong>
                    <span v-on:click="showAllTo" class="active">All</span>
                    <span v-on:click="showFlexTo">Flex</span>
                    <span v-on:click="showHighbandwidthTo">High Bandwidth</span>
                    <span @click="showSimonPlansTo">Simon Plans</span>
                    <span @click="showTmobilePlansTo">T-Mobile Plans</span>
                </div>
            </div>
            <div class="modal-content">
                <div v-if="templateLists.length > 0 && !loading" class="templates-wrap" id="templates-wrap">
                    <div v-if="selectedCarrrier != 2" class="simon-plans">
                        <div v-for="(templateItem, index) in templateLists" :key="templateItem.id" :id="'template-' + templateItem.id"
                             :class="[
                                 'template-item',
                                 templateItem.categoryClass,
                                 (templateItem.active == 1) ? 'plan-active' : 'plan-inactive',
                                 (templateItem.categoryClass != 'flex' && selectedPlans == 3) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'highbandwidth' && selectedPlans == 4) ? 'plan-hidden' : '',
                                 (templateItem.categoryClass != 'nb-iot' && selectedPlans == 5) ? 'plan-hidden' : ''
                                 ]"  @click="selectPlanTo(templateItem.id, 1)">
                            <div class="inner-template">
                                <div class="carrier-logo simon">
                                    <img src="../../assets/img/darklogo.svg" alt="">

                                    <div class="controls">
                                        <a class="deactivate" v-on:click="confirmdelete(index, templateItem.id, templateItem.name)">Deactivate</a>
                                        <div class="tooltip-on-hover">
                                            <h3>Deactivate Rate Plan</h3>
                                            <p>Selecting This Will Disable This Rate Plan from Future Use</p>
                                            <p>Note: It Wont Affect SIMs Currently on this Plan</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.name }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <span class="name">{{ templateItem.category }}</span>
                                            <span class="value">{{ templateItem.dataLimit }}</span>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">International Roaming</span>
                                                <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Data Pooling</span>
                                                <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>

                                            <div class="option">
                                                <span class="name">Throttle</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>

                                            <div class="option">
                                                <span class="name">Cap</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt && templateItem.dataGuard.capAtUnit">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                    <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                            <div class="option">
                                                <span class="name">Alert</span>
                                                <div class="wrap-value">
                                                    <span v-if="templateItem.usageAlert && templateItem.usageAlert.limit > 0">{{templateItem.usageAlert.limit}} {{templateItem.usageAlert.unit}}</span>
                                                    <span class="value" v-if="templateItem.usageAlert && templateItem.usageAlert.limit > 0">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="down">
                                            <div class="description">
                                                <span class="name">Plan Description</span>
                                                <span class="value">{{templateItem.description}}</span>
                                            </div>

                                            <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                <div class="start-price">
                                                    <span>Start Price</span>
                                                    <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                </div>

                                                <div class="static-ip">
                                                    <span>Static IP</span>
                                                    <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                </div>

                                                <div v-if="templateItem.planPrice.custom == false" class="discount">
                                                    <span>Discount</span>
                                                    <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                </div>

                                                <div class="cost-per-sim">
                                                    <span>Cost per SIM</span>
                                                    <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedCarrrier == 2 || selectedCarrrier == 0" class="tmobile-plans plans-list">
                        <div v-for="(templateItem, index) in ratePlanAssigned" v-bind:key="index" :id="'template-' + templateItem.ratePlanId" :data-ratePlanId="templateItem.ratePlanId" :class="['template-item', 'flex']" @click="selectPlanTo(templateItem.ratePlanId, 2)">
                            <div class="inner-template">
                                <div class="carrier-logo tmobile">
                                    <img src="../../assets/img/magenta-logo.svg" alt="">
                                </div>

                                <div class="plan-content">
                                    <div class="up">
                                        <div class="plan-name">
                                            <h2>{{ templateItem.planName }}</h2>
                                        </div>

                                        <div class="type-plan">
                                            <div class="name">{{ templateItem.planCategory.category }}</div>
                                        </div>

                                        <div class="options">
                                            <div class="option">
                                                <span class="name">Static IP</span>
                                                <span class="value" v-if="templateItem.staticIp">ON</span>
                                                <span class="value" v-else>OFF</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="down">
                                        <div class="description">
                                            <span class="name">Plan Description</span>
                                            <span v-if="templateItem.planDescription" class="value">{{templateItem.planDescription}}</span>
                                            <span v-else class="value">--</span>
                                        </div>

                                        <div class="price">
                                            <span class="name">Cost Per Line</span>
                                            <span v-if="templateItem.customUnitPrice" class="value">{{templateItem.customUnitPrice}}</span>
                                            <span v-else class="value">--</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="templates-wrap no-templates text-center">
                    <p>No plans have been made. Click here to here make a plan. </p>
                    <button class="btn btn-success" v-on:click="goToCreatePlan"><i class="fa fa-plus"></i>Add New Plan</button>
                </div>
            </div>
        </b-modal>
        <b-modal centered ref="simActions" id="simActions" :class="['modal-actions-sim']" hide-footer>
            <img v-if="simAction.type == 'reset' || simAction.type == 'suspend' || simAction.type == 'deactive'" src="../../assets/img/sim-card.png" alt />
            <img v-if="simAction.type == 'active'" src="../../assets/img/sim-card2.png" alt />
            <img v-if="simAction.type == 'restore'" src="../../assets/img/sim-card4.png" alt />

            <h3>{{simAction.title}}</h3>
            <h4>{{simAction.subtitle}}</h4>

            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['simActions'].hide()">No</b-button>
                <b-button variant="success" @click="actionSimFromModal()">Yes</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from '../../variables'
import Paginate from 'vuejs-paginate'
import XLSX from 'xlsx';


export default {
    name: 'showModal',
    data() {
        return {
            simFile: '',
            filterModal: '',
            sortSettingsModal: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true,
                selectedRatePlan: ''
            },
            simsList: '',
            selectedAllModal: 'false',
            paginationCountModal: 0,
            loadingSimListModal: true,
            noSimsModal: false,
            typingTimer: '',
            selectedRowsModal: [],
            selectedRowsModalParsed: [],
            custom1: '',
            custom2: '',
            searchStringModal: '',
            simAction: {
                type: 'reset',
                title: 'Reset SIM connection',
                subtitle: 'Are you sure you want to do this?'
            },
            selectAllSimsRatePlan: false,
            selectedActions: true,
            selectedChangePlan: false,
            selectedSimSwap: false,
            simSwapStep1: false,
            simSwapStep2: false,
            filterColdStock: '',
            searchStringColdStock: '',
            sortSettingsColdStock: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true,
            },
            coldStockList: [],
            loadingColdSims: true,
            noColdStock: false,
            selectedColdStockArr: [],
            selectedAllColdStock: 'false',
            paginationCountColdStock: 0,
            typingTimerColdStock: '',
            templateLists: [],
            selectedPlans: 1,
            ratePlanAssigned: [],
            selectedPlansFrom: 3,
            selectedPlanFrom: {
                iccid: 0,
                carrierId: 0
            },
            selectedPlansTo: 3,
            selectedPlanTo: {
                iccid: 0,
                carrierId: 0
            },
            ratePlanSelectedFrom: [],
            selectedCarrrier: 0,
            stateSelectedAll: false,
            selectedCarrierUrl: '',
            selectedAllModal: 'false',
            loading: false
        }
    },
    components: {
        Paginate: Paginate
    },
    methods: {
        selectCarrier(id) {
            this.selectedCarrrier = id
            this.selectedCarrierUrl = '&carrierId='+id
            this.startModalApp();
            this.$refs['selectCarrier'].hide()
            this.$refs['bulk-modal'].show()
        },
        swapColdSims() {
            if (this.selectedRowsModal.length == this.selectedColdStockArr.length) {
                let simsToSwap = []

                for (let i = 0; i < this.selectedRowsModal.length; i++) {
                    let item = {}
                    item.iccid = this.selectedRowsModal[i]
                    item.newIccid = this.selectedColdStockArr[i]

                    simsToSwap.push(item)
                }

                let dataToSwap = {
                    carrierId: this.selectedCarrrier,
                    items: simsToSwap
                }

                Axios.put(`${globalStore.data.restApiUrl}/sim-swap/bulk`, dataToSwap)
                    .then(response => {
                        if (response.status == '201') {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            });
                            this.unselectAllRowModal()
                            this.$refs['bulk-modal'].hide()
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something was wrong with SIM SWAP',
                            text: 'Something was wrong on backend side. Please look into console.',
                            duration: 5000,
                        });
                        console.log(error)
                        return false;
                    })

            } else {
                if (this.selectedRowsModal.length > this.selectedColdStockArr.length) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong count selected SIMs',
                        text: 'You selected too much SIMs and not enought Cold SIMs',
                        duration: 5000,
                    });
                    return false;
                } else {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Wrong count selected SIMs',
                        text: 'You selected too much Cold SIMs and not enought SIMs',
                        duration: 5000,
                    });
                    return false;
                }
            }
        },
        goToSwapSim() {
            let testStatusSim = false;

            for (let j = 0; j < this.selectedRowsModalParsed.length; j++) {
                if (this.selectedRowsModalParsed[j]['status'] != 'Active') {
                    testStatusSim = true
                }
            }
            if (testStatusSim == true) {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Wrong selected SIMs',
                    text: 'You selected wrong SIMs to SWAP. Only Active SIMs can be SWAPED',
                    duration: 5000,
                });
                return false
            } else {
                this.simSwapStep2 = true
            }
        },
        selectPlanFrom(iccid, carrierId) {

            this.selectedPlanFrom.iccid = iccid;
            this.selectedPlanFrom.carrierId = carrierId;

            if (carrierId == 1) {
                this.ratePlanSelectedFrom = this.templateList.filter(item => {
                    return item.id == this.selectedPlanFrom.iccid
                })
            } else if (carrierId == 2) {
                this.ratePlanSelectedFrom = this.ratePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanFrom.iccid
                })
            }

            this.ratePlanSelectedFrom = this.ratePlanSelectedFrom[0]
            this.sortSettingsModal.selectedRatePlan = '&rpid=' + iccid + '&exin=true';
            this.loadingSimListModal = true;
            this.getSimsListModal(true)

            this.$refs['select-from-plan'].hide()
        },
        selectPlanTo(iccid, carrierId) {
            this.selectedPlanTo.iccid = iccid;
            this.selectedPlanTo.carrierId = carrierId;

            if (carrierId == 1) {
                this.ratePlanSelectedTo = this.templateList.filter(item => {
                    return item.id == this.selectedPlanTo.iccid
                })
            } else if (carrierId == 2) {
                this.ratePlanSelectedTo = this.ratePlanAssigned.filter(item => {
                    return item.ratePlanId == this.selectedPlanTo.iccid
                })
            }

            this.ratePlanSelectedTo = this.ratePlanSelectedTo[0]

            this.$refs['select-to-plan'].hide()
        },
        checkSelectedRow(iccid) {
            let checkSim = this.selectedRowsModal.filter(item => {
                return item.iccid == iccid
            })

            if (checkSim.length > 0) {
                return true
            } else {
                return false
            }
        },
        closeModal() {
            this.$refs['bulk-modal'].hide()
            this.unselectAllRowModal()
        },
        showAllFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 3;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var k = 0; k < planItems.length; k++) {
                planItems[k].style.display = ''
            }
        },
        showFlexFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 0;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var j = 0; j < planItems.length; j++) {
                if (planItems[j].classList.contains('flex')) {
                    planItems[j].style.display = ''
                } else {
                    planItems[j].style.display = 'none'
                }
            }
        },
        showHighbandwidthFrom(ev) {
            ev.preventDefault();

            this.selectedPlansFrom = 0;

            if (!ev.target.classList.contains("active")) {
                document.querySelector(".filters-plan span.active").classList.remove('active');
                ev.target.classList.add('active')
            }

            var planWrapper = document.getElementById("select-from-plan___BV_modal_body_");
            var planItems = planWrapper.getElementsByClassName("template-item");

            for (var j = 0; j < planItems.length; j++) {
                if (planItems[j].classList.contains('highbandwidth')) {
                    planItems[j].style.display = ''
                } else {
                    planItems[j].style.display = 'none'
                }
            }
        },
        showSimonPlansFrom(ev) {
            this.selectedPlansFrom = 1
            document.querySelector("#select-from-plan___BV_modal_body_ span.active").classList.remove('active');
            ev.target.classList.add('active')
        },
        showTmobilePlansFrom(ev) {
            this.selectedPlansFrom = 2;
            document.querySelector("#select-from-plan___BV_modal_body_ span.active").classList.remove('active');
            ev.target.classList.add('active')
        },
        showAllTo() {

        },
        goToCreatePlan() {

        },
        showFlexTo() {

        },
        showHighbandwidthTo() {

        },
        showSimonPlansTo() {

        },
        showTmobilePlansTo() {

        },
        actionSimFromModal() {
            this.$refs['simActions'].hide()

            this.loadingSimListModal = true;

            if (this.selectedRowsModal.length == 0) {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Please select SIMs',
                    text: 'Please Select SIMs for Bulk Operation',
                    duration: 5000,
                });
                return false;
                this.loadingSimListModal = false;
            }

            if (this.simAction.type == 'suspend') {

                let checkDeactiveStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Deactive' || sim.status == 'Deactivated'
                })

                let checkSuspendStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Suspend' || sim.status == "Suspended"
                })

                if (checkDeactiveStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else if (checkSuspendStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else {

                    let dataSimToSuspend = {
                        iccids: this.selectedRowsModal
                    };

                    Axios.post(globalStore.data.restApiUrl + "/subscriber/suspend", dataSimToSuspend)
                        .then(response => {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            })
                            this.getSimsListModal(true);
                            this.loadingSimListModal = false;
                        }).catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Something was wrong',
                                text: 'Error Processing Bulk Suspend - Contact Support',
                                duration: 5000,
                            });
                            console.log(error)
                            this.loadingSimListModal = false;
                        });
                }

            } else if (this.simAction.type == 'restore') {
                let checkDeactiveStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Deactive' || sim.status == 'Deactivated'
                })

                let checkActiveStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Active' || sim.status == "Activated"
                })

                if (checkDeactiveStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else if (checkActiveStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else {

                    let dataSimToRestore = {
                        iccids: this.selectedRowsModal
                    };

                    Axios.post(globalStore.data.restApiUrl + "/subscriber/restore", dataSimToRestore)
                        .then(response => {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            });
                            this.getSimsListModal(true);
                            this.loadingSimListModal = false;
                        }).catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Something was wrong',
                                text: 'Error Processing Bulk Restore - Contact Support',
                                duration: 5000,
                            });
                            console.log(error)
                            this.loadingSimListModal = false;
                        });
                }
            } else if (this.simAction.type == 'deactive') {
                let checkDeactiveStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Deactive' || sim.status == 'Deactivated'
                })

                if (checkDeactiveStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else {

                    let dataSimToRestore = {
                        iccids: this.selectedRowsModal
                    };

                    Axios.post(globalStore.data.restApiUrl + "/subscriber/deactivate", dataSimToRestore)
                        .then(response => {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            });
                            this.getSimsListModal(true);
                            this.loadingSimListModal = false;
                        }).catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Something was wrong',
                                text: 'Error Processing Bulk SIM Deactivation - Contact Support',
                                duration: 5000,
                            });
                            console.log(error)
                            this.loadingSimListModal = false;
                        });
                }
            } else if (this.simAction.type == 'reset') {
                let checkDeactiveStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Deactive' || sim.status == 'Deactivated'
                })

                let checkSuspendStatus = this.selectedRowsModalParsed.filter(sim => {
                    return sim.status == 'Suspend' || sim.status == "Suspended"
                })

                if (checkDeactiveStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else if (checkSuspendStatus.length > 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Bulk action error',
                        text: 'Invalid SIM Selected for Bulk Operation',
                        duration: 5000,
                    });
                    this.loadingSimListModal = false;
                } else {

                    var simIds = {
                        iccids: this.selectedRowsModal
                    };

                    Axios.post(globalStore.data.restApiUrl + '/subscriber/cancel-device-location', simIds)
                        .then(response => {
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Transaction in Progress',
                                text: 'This Transaction is Now in Progress. If you want to see the details: <a href="/?#/transaction/' + response.data.transactionId + '">Click here</a>',
                                duration: 5000,
                            });
                            this.getSimsListModal(true);
                            this.loadingSimListModal = false;
                        }).catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Something was wrong',
                                text: 'Error Processing Bulk Reset Device Connection - Contact Support',
                                duration: 5000,
                            });
                            console.log(error)
                            this.loadingSimListModal     = false;
                        })
                }
            }
        },
        getRatePlans() {
            Axios.get(globalStore.data.restApiUrl + "/account/rate-plans").then(result => {
                this.templateList = [];
                this.templateLists = [];
                const templateLists = result.data.response;

                if (templateLists.length) {
                    templateLists.map(item => {
                        var optionsSms = "OFF";
                        var optionsDataPooling = "OFF";
                        var roaming = "OFF";
                        var tier = null;
                        var roaming2 = "OFF";
                        var tier2 = null;
                        var staticIp = "OFF";

                        if (item.planOptions) {
                            item.planOptions.map(itemOptions => {
                                if (itemOptions.planOptionName == "SMS") {
                                    optionsSms = "ON";
                                }

                                if (itemOptions.planOptionName == "Data Pooling") {
                                    optionsDataPooling = "ON";
                                }

                                if  (itemOptions.planOptionName == "Tier 1 International Roaming") {
                                    roaming = "ON";
                                    tier = 'Tier 1';
                                }

                                if  (itemOptions.planOptionName == "Tier 2 International Roaming") {
                                    roaming2 = "ON";
                                    tier2 = 'Tier 2';
                                }

                                if (itemOptions.planOptionName == "Static IP") {
                                    staticIp = "ON";
                                }
                            });
                        }

                        var dataGuard = {
                            hasThrottle: 0,
                            throttleAt: 0,
                            throttleAtUnit: "",
                            throttleSpeed: 0,
                            hasCap: 0,
                            capAt: 0,
                            capAtUnit: ""
                        }

                        if (item.dataGuard) {
                            if (item.dataGuard.hasThrottle == 1) {
                                dataGuard.hasThrottle = 1;

                                if (item.dataGuard.throttleAt > 0) {
                                    dataGuard.throttleAt = item.dataGuard.throttleAt;
                                    dataGuard.throttleAtUnit = item.dataGuard.throttleAtUnit;
                                }

                                if (item.dataGuard.throttleSpeed && item.dataGuard.throttleSpeed.throttleSpeedId > 0) {
                                    dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName;
                                }
                            }

                            if (item.dataGuard.hasCap == 1) {
                                dataGuard.hasCap = 1;

                                if (item.dataGuard.capAt > 0) {
                                    dataGuard.capAt = item.dataGuard.capAt;
                                    dataGuard.capAtUnit = item.dataGuard.capAtUnit;
                                }
                            }

                        }

                        if (dataGuard.hasThrottle == 0) {
                            delete dataGuard.throttleAt
                            delete dataGuard.throttleAtUnit
                            delete dataGuard.throttleSpeed
                        }

                        if (dataGuard.hasCap == 0) {
                            delete dataGuard.capAt
                            delete dataGuard.capAtUnit
                        }

                        var categoryClass = item.planCategory.planCategoryName;
                        categoryClass = categoryClass.replace(/\s/g, "").toLowerCase();

                        var tempTemplateData = {
                            id: item.ratePlanId,
                            name: item.planName,
                            active: item.active,
                            description: item.planDescription,
                            category: item.planCategory.planCategoryName,
                            categoryClass: categoryClass,
                            dataLimit: item.dataLimit.dataLimitName,
                            planOptions: {
                                dataPooling: optionsSms,
                                sms: optionsSms,
                                hasRoaming: roaming,
                                tier: tier,
                                staticIp: staticIp,
                                hasRoaming2: roaming2
                            },
                            dataGuard: dataGuard
                        };
                        this.templateLists.push(tempTemplateData);
                    });
                }

                this.templateList = this.templateLists;
            });
        },
        actionSim(typeAction) {
            if (typeAction == 'restore') {
                this.simAction.type = 'restore',
                this.simAction.title = 'Restore SIM',
                this.simAction.subtitle = 'Are you sure you want to do this?'
            } else if (typeAction == 'deactive') {
                this.simAction.type = 'deactive',
                this.simAction.title = 'Deactivate SIM',
                this.simAction.subtitle = 'Are you sure you want to do this?'
            } else if (typeAction == 'suspend') {
                this.simAction.type = 'suspend',
                this.simAction.title = 'Suspend SIM',
                this.simAction.subtitle = 'Are you sure you want to do this?'
            } else if (typeAction == 'reset') {
                this.simAction.type = 'reset',
                this.simAction.title = 'Reset SIM connection',
                this.simAction.subtitle = 'Are you sure you want to do this?'
            }
            this.$refs['simActions'].show();
        },
        selectRowModal(id, status) {

            if (typeof id == "string") {
                let parsedData = {
                    iccids: [],
                    forceOff: null
                };
                if (this.selectedRowsModal.indexOf(id) != -1) {
                    this.selectedRowsModal.splice(this.selectedRowsModal.indexOf(id), 1);
                    for (let i = 0 ; i < this.selectedRowsModalParsed.length ; i++) {
                        if (this.selectedRowsModalParsed[i].iccid == id) {
                            this.selectedRowsModalParsed.splice(i, 1);
                        }
                    }
                    parsedData = {
                        iccids: [id],
                        forceOff: true
                    };
                } else {
                    this.selectedRowsModal.push(id)
                    this.selectedRowsModalParsed.push({iccid: id, status: status})
                    parsedData = {
                        iccids: [id],
                        forceOn: true
                    };
                }
                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
                this.setSelectAllModal();
            } else if (typeof id == "object") {

                let parsedData = {
                    iccids: null,
                    forceOn: null
                };

                if (this.selectedAllModal == 'true') { // zaznacz

                    let newId = []

                    for (let singleIccid in id) {
                        newId.push(id[singleIccid]['iccid'])
                    }

                    parsedData = {
                        iccids: newId,
                        forceOn: true
                    };

                    id.map(sim => {
                        this.selectedRowsModal.push(sim.iccid)
                        this.selectedRowsModalParsed.push({iccid: sim.iccid, status: sim.status})
                    })

                } else { // odznacz

                    let newId = []

                    for (let singleIccid in id) {
                        newId.push(id[singleIccid]['iccid'])
                    }

                    parsedData = {
                        iccids: newId,
                        forceOff: true
                    };

                    id.map(sim => {
                        this.selectedRowsModal.splice(this.selectedRowsModal.indexOf(sim.iccid), 1);
                        this.selectedRowsModalParsed.filter((row, key) => {
                            if (row.iccid == sim.iccid){
                                this.selectedRowsModalParsed.splice(key, 1);
                            }
                        })
                    })
                }

                Axios.post(globalStore.data.restApiUrl + '/sims/mark', parsedData)
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Selected SIM failed',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    });
                this.setSelectAllModal();
            }
        },
        unselectAllRowModal() {
            this.selectedPlansFrom = 3
            this.selectedPlansTo = 3
            this.selectedPlanFrom.iccid = 0;
            this.selectedPlanFrom.carrierId = 0
            this.selectedPlanTo.iccid = 0;
            this.selectedPlanTo.carrierId = 0
            this.sortSettingsModal.selectedRatePlan = ''
            this.selectedRowsModalParsed = []
            // this.getSimsListModal(true)
            this.selectedColdStockArr = [];
            Axios.delete(globalStore.data.restApiUrl + "/sims/mark")
                .then(response => {
                    this.selectedRowsModal = []
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Unselecting SIM cards on the server side failed.',
                        text: 'Error Processing SIM Selection - Contact Support',
                        duration: 3000,
                    });
                    console.log(error);
                });
        },
        changeRatePlan() {
            let targetId = {
                targetPlanId: this.selectedPlanTo.iccid
            }

            Axios.post(globalStore.data.restApiUrl + '/sim-plan/bulk-change', targetId)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Changing mass rate plan success.',
                        text: 'Mass change rate plan was scheduling with success.',
                        duration: 5000,
                    });

                    this.$refs['bulk-modal'].hide()
                }).catch(error => {
                    if (error.response.data.errors.length > 0) {
                        const errors = error.response.data.errors;
                        errors.map(item => {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Unable to complete the bulk plan change.',
                                text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                                duration: 5000,
                            });
                        })
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Unable to complete the bulk plan change.',
                            text: 'Error Processing Bulk Rate Plan Change - Contact Support',
                            duration: 5000,
                        });
                    }
                    console.log(error)
                })
        },
        selectAllRowsModal() {
            let selected = false;

            if (this.selectedAllModal == 'true') {
                this.selectedAllModal = 'false';
            } else {
                this.selectedAllModal = 'true'
                selected = true;
            }
            let prepareIccids = [];

            if (selected) {
                for (let i = 0 ; i < this.simsList.length ; i++) {
                    if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) == -1) {
                        prepareIccids.push({'iccid': this.simsList[i].iccid, 'status': this.simsList[i].status});
                    }
                }
            } else {
                for (let i = 0 ; i < this.simsList.length ; i++) {
                    if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) != -1) {
                        prepareIccids.push({'iccid': this.simsList[i].iccid, 'status': this.simsList[i].status});
                    }
                }
            }
            this.selectRowModal(prepareIccids);
        },
        changesSortModal(ev) {
            this.sortSettingsModal.sort = ev.target.getAttribute("aria-colindex");

            if (ev.target.getAttribute("aria-sort") == 'none') {
                document.querySelectorAll("table.table-managment thead th[aria-sort]").forEach(item => {
                    item.setAttribute("aria-sort", 'none')
                })
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettingsModal.desc = false
            } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                ev.target.setAttribute("aria-sort", 'descending')
                this.sortSettingsModal.desc = true
            } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettingsModal.desc = false
            }
            this.getSimsListModal(true)
        },
        searchKeyUpModal() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRowModal()
            }, 500)
        },
        searchKeyDownModal() {
            clearTimeout(this.typingTimer)
        },
        searchRowModal() {
            this.loadingSimListModal = true;
            if (this.filterModal.length > 0) {
                this.searchStringModal = '&search=' + this.filterModal;
            } else {
                this.searchStringModal = '';
            }

            this.getSimsListModal(true)
        },
        showModal() {
            this.unselectAllRowModal()
            this.$refs['selectCarrier'].show()
        },
        readSimFileModal(ev) {
            if (ev.target) {
                var f = ev.target.files[0];
            } else {
                var f = ev[0];
            }

            var ext = f.name.slice(f.name.lastIndexOf("."));

            if (ext === ".csv") {

                var ret = [];
                var r = new FileReader();
                var tempThis = this;
                r.onload = function(e) {
                    var ct = r.result;
                    var words;

                    ct.indexOf("\n") > -1 ? words = ct.split("\n") : null;

                    if (typeof(words) == 'object') {
                        let tempArr = [];

                        for (let i = 0; i < words.length; i++) {
                            if (words[i].indexOf(",") > -1) {
                                let temptempArr = words[i].split(",");
                                for (let item in temptempArr) {
                                    if (temptempArr[item].length > 0) {
                                        tempArr.push(temptempArr[item])
                                    }
                                }
                            } else {
                                tempArr.push(words[i]);
                            }
                        }

                        words = tempArr
                    } else {
                        (ct.indexOf(",") > -1) ? words = ct.split(",") : null;
                    }

                    var len = words.length;
                    for (let i = 0 ; i < len ; i++){
                        words[i] = words[i].replace(/\D/g,'');
                        words[i] != "" ? ret.push(words[i]) : null;
                    }
                    tempThis.addSimArrayCheckedModal(ret);
                }
                r.readAsText(f);
            } else if (ext === '.txt') {

                var ret = [];
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                if (f) {
                    var r = new FileReader();
                    var tempThis = this;
                    r.onload = function(e) {
                        var ct = r.result;

                        ct.indexOf("\n") > -1 ? ct = ct.split("\n") : null;

                        if (typeof(ct) == 'object') {
                            let tempArr = [];

                            for (let i = 0; i < ct.length; i++) {
                                if (ct[i].indexOf(",") > -1) {
                                    let temptempArr = ct[i].split(",");
                                    for (let item in temptempArr) {
                                        if (temptempArr[item].length > 0) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    }
                                } else {
                                    tempArr.push(ct[i]);
                                }
                            }

                            ct = tempArr
                        } else {
                            ct.indexOf(",") > -1 ? ct = ct.split(",") : null;
                        }

                        var len = ct.length;
                        for (var i = 0 ; i < len ; i++) {
                            ct[i] = ct[i].replace(/\D/g,'');
                        }
                        let parsedTxtArray = [];
                        for (let item of ct) {
                            if (item != "") {
                                parsedTxtArray.push(item);
                            }
                        }

                        tempThis.addSimArrayCheckedModal(parsedTxtArray)
                    }
                    r.readAsText(f);
                } else {
                    alert("Failed to load file");
                }
            } else if ( ext== '.xls' || ext === ".xlsx" ) {
                var tempThis = this;

                let formData = new FormData();
                formData.append('file', ev.target.files[0]);
                Axios.post(`${globalStore.data.restApiUrl}/sims/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(response => {
                        let simsNumber = response.data
                        tempThis.addSimArrayCheckedModal(simsNumber)
                    }).catch(error => {
                        console.log(error)
                    })

            }
        },
        ProcessExcel(data) {
            console.log('in process')
            var workbook = XLSX.read(data, {
                type: 'binary'
            });

            var firstSheet = workbook.SheetNames[0];

            var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);

            let tempArray = [];

            for(let i = 0 ; i < excelRows.length ; i++){
                console.log(String(excelRows[i][Object.keys(excelRows[i])[0]]));
                //tempArray.push(String(excelRows[i][Object.keys(excelRows[i])[0]]));
            }
            //this.addSimCheckedModal(tempArray);
        },
        addSimCheckedModal(sims) {
            let tempThis = this;
            sims.map(sim => {
                Axios.get(globalStore.data.restApiUrl + '/sims/' + sim)
                    .then(response => {
                        if (response.status == 200 && response['data']['count'] > 0) {
                            tempThis.selectRowModal(response.data.response[0]['iccid'], response.data.response[0]['status']);
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Sim number not exist in base',
                                text: 'Invalid SIM Present During Upload - Not Found - Contact Support',
                                duration: 5000,
                            });
                        }

                    }).catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting sim details error',
                            text: 'We have error with get status of sims from file, please check if this sim number is right.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            })
        },
        addSimArrayCheckedModal(sims) {
            let tempThis = this;

            Axios.post(globalStore.data.restApiUrl + '/sims/info', sims)
                .then(response => {
                    for (let item of response.data) {
                        this.selectRowModal(item.iccid, item.status);
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting sim details error',
                    text: 'We have error with get status of sims from file, please check if this sim number is right.',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        selectActionsModal() {
            this.simSwapStep2 = false;
            this.selectedActions = true
            this.selectedChangePlan = false
            this.selectedSimSwap = false
        },
        selectPlanModal() {
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = true
            this.selectedSimSwap = false
        },
        selectSwapModal() {
            this.simSwapStep2 = false;
            this.selectedActions = false
            this.selectedChangePlan = false
            this.selectedSimSwap = true
            this.simSwapStep1 = true
        },
        sizePageModal() {
            this.loadingSimListModal = true;
            this.getSimsListModal(true)
        },
        getSimsListModal(notPagination) {
            this.simsList = []
            this.loadingSimListModal = true;
            if (notPagination){
                this.sortSettingsModal.page = 1;
            }
            this.getPaginationModal();
            Axios.get(globalStore.data.restApiUrl + "/sims" + '?page=' + this.sortSettingsModal.page + '&size=' + this.sortSettingsModal.size + '&sort=' + this.sortSettingsModal.sort + '&desc=' + this.sortSettingsModal.desc + this.searchStringModal + this.sortSettingsModal.selectedRatePlan + this.selectedCarrierUrl)
                .then(response => {
                    if (response.status == 200) {

                        if (response.data.response.length > 0) {
                            this.noSimsModal = false;
                            let simList = response.data.response;
                            let selectedCount = 0;

                            simList.map(simRow => {
                                if (simRow.customFields) {
                                    simRow.customFields.map(customField => {
                                        if (customField.customFieldId == 1) {
                                            simRow.customField1 = customField.customFieldName
                                        }

                                        if (customField.customFieldId == 2) {
                                            simRow.customField2 = customField.customFieldName
                                        }
                                    })
                                }

                                let checkedSimModal = this.selectedRowsModal.filter(item => {
                                    return item.iccid == simRow.iccid
                                })

                                if (checkedSimModal.length > 0) {
                                    selectedCount++
                                }
                            })

                            this.simsList = simList;
                            this.loadingSimListModal = false;
                            this.setSelectAllModal()

                            if (document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr')) {
                                if (selectedCount == this.sortSettingsModal.size) {
                                    document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr').setAttribute('aria-selected', 'true')
                                } else {
                                    document.querySelector('#bulk-modal___BV_modal_body_ .table-managment thead tr').setAttribute('aria-selected', 'false')
                                }
                            }
                        } else {
                            this.loadingSimListModal = false;
                            this.noSimsModal = true;
                            this.simsList = [];
                        }
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });
                        console.log(response)
                        this.loadingSimListModal = false;

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                    this.loadingSimListModal = false;

                    return false;
                });
        },
        getPaginationModal() {
            Axios.get(globalStore.data.restApiUrl + "/sim-page-count?size=" + this.sortSettingsModal.size + this.searchStringModal + this.sortSettingsModal.selectedRatePlan + this.selectedCarrierUrl)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCountModal = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });
                        console.log(response)

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)

                    return false;
                })
        },
        paginationControllModal(ev) {
            this.loadingSimListModal = true;
            this.sortSettingsModal.page = ev;
            document.querySelector('#bulk-modal___BV_modal_body_ thead tr').removeAttribute('aria-selected')
            this.getSimsListModal(false);
        },
        getCustomFields() {
            Axios.get(globalStore.data.restApiUrl + '/custom-fields')
                .then( response => {
                    this.customFields = response.data.hidden;
                    if (!this.customFields) {
                        response.data.fields.forEach(field => {
                            if (field.index == 1) {
                                this.custom1 = field.label;
                            } else if (field.index == 2) {
                                this.custom2 = field.label;
                            }
                        })
                    }
                })
        },
        selectFromPlan() {
            this.$refs['select-from-plan'].show()
        },
        selectToPlan() {
            this.$refs['select-to-plan'].show()
        },
        searchKeyUpColdStock() {
            clearTimeout(this.typingTimerColdStock)
            this.typingTimerColdStock = setTimeout(() => {
                this.searchRowColdStock()
            }, 500)
        },
        searchKeyDownColdStock() {
            clearTimeout(this.typingTimerColdStock)
        },
        searchRowColdStock() {
            if (this.filterColdStock.length > 0) {
                this.searchStringColdStock = '&search=' + this.filterColdStock;
            } else {
                this.searchStringColdStock = ''
            }
            this.getColdStocks(true)
        },
        selectRowColdStock(id) {
            if (this.selectedColdStockArr.indexOf(id) != -1) {
                this.selectedColdStockArr.splice(this.selectedColdStockArr.indexOf(id), 1);
            } else {
                this.selectedColdStockArr.push(id)
            }
        },
        sizePageColdStock() {
            this.loadingColdSims = true;
            this.getColdStocks(true)
        },
        selectAllRowsColdStock() {
            let selected = false;

            if (this.selectedAllColdStock == 'true') {
                this.selectedAllColdStock = 'false';
            } else {
                this.selectedAllColdStock = 'true'
                selected = true;
            }
            this.coldStockList.map(item => {
                if (selected) {
                    if (this.selectedColdStockArr.indexOf(item.iccid) == -1) {
                        this.selectRowColdStock(item.iccid);
                    }
                } else {
                    if (this.selectedColdStockArr.indexOf(item.iccid) != -1) {
                        this.selectRowColdStock(item.iccid);
                    }
                }
            })
        },
        paginationControllColdStock(ev) {
            this.loadingSimListModal = true;
            this.sortSettingsColdStock.page = ev;
            document.querySelector('#bulk-modal___BV_modal_body_ .table-coldstock thead tr').removeAttribute('aria-selected')
            this.getColdStocks(false);
        },
        getPaginationColdStock() {
            Axios.get(globalStore.data.restApiUrl + "/cold-stock/page-count?size=" + this.sortSettingsColdStock.size + '&carrierId=' + this.selectedCarrrier + this.searchStringColdStock)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCountColdStock = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                            duration: 5000,
                        });
                        console.log(response)

                        return false;
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                    duration: 5000,
                });
                console.log(error)

                return false;
            })
        },
        getColdStocks(notPagination) {
            if (notPagination){
                this.sortSettingsColdStock.page = 1;
            }
            this.getPaginationColdStock()
            Axios.get(`${globalStore.data.restApiUrl}/cold-stock?page=${this.sortSettingsColdStock.page}&size=${this.sortSettingsColdStock.size}&sort=${this.sortSettingsColdStock.sort}&desc=${this.sortSettingsColdStock.desc}&carrierId=${this.selectedCarrrier}${this.searchStringColdStock}`)
                .then(response => {
                    this.coldStockList = response.data
                    this.loadingColdSims = false
                }).catch(error => {
                    this.loadingColdSims = false
                     this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Something was wrong',
                        text: 'Error Retrieving SIM List for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    return false;
                })
        },
        getTmobileRatePlan() {
            Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=2`)
                .then(response => {
                    this.ratePlanAssigned = response.data.response
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Rate Plan Details for Bulk Operations - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        startModalApp() {
            this.getRatePlans()
            this.getTmobileRatePlan()
            this.getSimsListModal(true)
            this.getCustomFields()
            this.getColdStocks(true)
            this.selectActionsModal()
        },
        isSelectedColdStock(id) {
            let isSelected = false;
            if (this.selectedColdStockArr.indexOf(id) != -1) {
                isSelected = true;
            }
            return isSelected;
        },
        setSelectAllModal() {
            let isAllSelected = 0;
            for (let i = 0 ; i < this.simsList.length ; i++) {
                if (this.selectedRowsModal.indexOf(this.simsList[i].iccid) != -1) {
                    isAllSelected++;
                }
            }
            if ((this.simsList.length > 0) && (isAllSelected == this.simsList.length)) {
                this.selectedAllModal = 'true';
            } else {
                this.selectedAllModal = 'false';
            }
        },
        isSelected(id) {
            let isSelected = false;
            if (this.selectedRowsModal.indexOf(id) != -1) {
                isSelected = true;
            }
            return isSelected;
        },
    },
    created() {

    },
    mounted() {

    }
}
</script>

<style lang="scss">
#bulk-modal___BV_modal_outer_ {
    z-index: 3030 !important;

    .modal-body {
        display: flex;
        flex-direction: column;

        > * {
            height: 100%;

            &.select-actions {
                max-height: 23px;
            }

            &.dnd-area {
                max-height: 80px;
            }


        }
    }
}
#select-from-plan___BV_modal_outer_,
#select-to-plan___BV_modal_outer_  {
    z-index: 3040 !important;
    overflow-y: scroll;
}
#bulk-modal {
    z-index: 3020;
    height: 100%;
    overflow-y: scroll;
    padding-left: 0 !important;

    .modal-header {
        padding-bottom: 0;

        .modal-title {
            font-size: 15px;
            line-height: 21px;
            font-weight: 700;
        }
    }
    .modal-dialog {
        max-width: none;
        width: 95%;
        min-height: 93%;

        .modal-content {
            height: 100%;

            .select-actions {
                margin-bottom: 20px;
                button {
                    padding: 0;
                    margin-right: 30px;
                    text-transform: uppercase;
                    font-size: 15px;
                    line-height: 20px;
                    color: #000000;
                    text-decoration: none;

                    &.active {
                        font-weight: 700;
                        color: #0088FF;
                    }
                }
            }

            .dnd-area {
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                padding: 20px;
                margin-bottom: 20px;

                border: 2px dotted #2F353A;
                border-radius: 5px;

                .image {
                    margin-right: 20px;
                    img {
                        max-width: 60px;
                    }
                }

                .text {
                    margin-right: 25px;
                    h3 {
                        margin: 0;
                        font-size: 12px;
                        line-height: 24px;
                        color: #2F353A;
                    }
                    h4 {
                        margin: 0;
                        font-size: 12px;
                        line-height: 16px;
                        color: #979A9C;
                    }
                }

                .label {
                    input {
                        display: none;
                    }

                    label {
                        margin: 0;
                    }
                }
            }

            .migrate-plan {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 20px;

                h3 {
                    width: 100%;
                    font-size: 14px;
                    line-height: 22px;
                }

                .migrate-from,
                .migrate-to {
                    width: 49%;
                    min-height: 200px;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    text-align: center;

                    border: 1px solid #C9CFD4;

                    button {
                        margin-bottom: 8px;
                        box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
                    }

                    label {
                        margin-top: 20px;

                        input {
                            margin-right: 20px;
                        }
                    }
                }
            }

            .sims-list-wrapper {
                position: relative;
                .col-md-2 {
                    label {
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    .cold-sims-list {
        .col-md-2.text-right {
            label {
                margin-right: 10px;
            }
        }
    }
}

.bottom-table {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    align-content: flex-end;
    padding: 20px 0 0;

    nav {
        ul {
            margin-bottom: 0;
        }
    }

    .button-wrapper {
        button {
            margin-left: 10px;

            &.migrate {
                background-color: #55CD6C;
                border-color: #55CD6C;
            }
        }
    }
}

#select-from-plan,
#select-to-plan {
    z-index: 3050;

    .modal-header {
        padding-bottom: 0;
        margin-bottom: 23px;

        .modal-title {
            font-size: 15px;
            line-height: 21px;
            font-weight: 700;
        }
    }
    .modal-dialog {
        max-width: none;
        width: 95%;
        min-height: 93%;

        .modal-content {
            background-color: #F0F3F5;
            border: 0;
        }

        .modal-body {
            .modal-header {
                padding: 0;
                flex-direction: column;

                .rate-plan-name {
                    display: block;
                    margin-bottom: 20px;
                    font-size: 15px;
                    font-weight: 700;
                    color: #2F353A;
                }

                .filters-plan {
                    span {
                        margin-left: 10px;
                        cursor: pointer;

                        &.active {
                            font-weight: 700;
                        }
                    }
                }
            }

            .modal-content {
                .templates-wrap {
                    border: 0;

                    &.no-templates {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        align-items: center;
                    }

                    .simon-plans {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .tmobile-plans {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .template-item {
                        cursor: pointer;
                        &.plan-inactive {
                            opacity: .5;
                        }
                    }
                }
            }
        }

    }
}

#simActions___BV_modal_outer_ {
    z-index: 3040 !important;

    .modal-body {
        padding-top: 0;
        text-align: center;

        img {
            max-width: 16px;
            margin-bottom: 16px;
        }

        h3 {
            font-size: 15px;
            line-height: 20px;
            font-weight: 700;
            color: #2F353A;
        }

        h4 {
            display: block;
            margin-bottom: 40px;
            font-size: 14px;
            line-height: 24px;
            color: #515B65;
        }

        .button-wrapper {
            text-align: center;

            button {
                margin: 0 10px;
            }
        }
    }
}

.inner-migrate {
    width: 100%;
    padding: 20px;
    .header-plan {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;

        .title {
            width: 100%;
            text-align: left;
            h3 {
                margin: 0;
                font-size: 15px;
                line-height: 20px;
                font-weight: 700;
                color: #3A4149;
            }

            .category {
                display: flex;
                justify-content: space-between;

                h4 {
                    margin: 0;
                    font-size: 22px;
                    line-height: 29px;
                    font-weight: 700;
                    text-transform: uppercase;
                }

                em {
                    font-size: 22px;
                    line-height: 29px;
                    font-weight: 700;
                    color: #2F353A;
                    font-style: normal;
                }

                &.magenta {
                    h4 {
                        color: #e20074;
                    }
                }
            }
        }

        .button {
            width: 100%;
            text-align: right;
        }
    }

    .body-plan {
        padding: 10px 0;
        margin: 10px 0;
        border-top: 1px solid #D5D6D7;
        border-bottom: 1px solid #D5D6D7;

        .list-options {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item-options {
                width: 48%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;

                span {
                    font-size: 14px;
                }

                em {
                    font-style: normal;
                    font-weight: 700;
                    text-transform: uppercase;
                    font-weight: 14px;
                    color: #515B65;
                }

                &.true {
                    em {
                        color: #55CD6C;
                    }
                }
            }
        }
    }

    .plan-description {
        text-align: left;
    }
}
selectCarrier___BV_modal_header_ {
    padding: 16px;
}

#selectCarrier___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    padding-top: 0;
    padding-bottom: 20px;

    img {
        max-width: 16px;
        margin-bottom: 12px;
    }

    strong {
        margin-bottom: 18px;
        font-size: 15px;
        line-height: 20px;
    }

    p {
        font-size: 14px;
        line-height: 24px;
    }

    .select-carrier-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        .carrier-option {
            display: flex;
            align-items: center;
            width: 180px;
            padding: 10px 20px;

            border: 1px solid #80868D;
            border-radius: 5px;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
            opacity: .6;

            &:hover {
                opacity: 1;
            }

            label {
                margin: 0;
                img {
                    width: 100%;
                    max-width: none;
                    margin: 0;
                    cursor: pointer;
                }
                .light-mode {
                    display: block;
                }
                .dark-mode {
                    display: none;
                }
            }


        }
    }
}

.dark-theme {
    #selectCarrier___BV_modal_content_ {
        background-color: #3A4149;
        #selectCarrier___BV_modal_header_ {
            color: #edeeef;
            .close {
                color: #edeeef;
                opacity: 1;
            }
        }
    }
    #selectCarrier___BV_modal_body_ {
        .select-carrier-box {
            .carrier-option {
                label {
                    display: block;
                    .light-mode {
                        display: none;
                    }
                    .dark-mode {
                        display: block;
                    }
                }
            }
        }
    }
    #bulk-modal___BV_modal_content_ {
        background-color: #3A4149;
        #bulk-modal___BV_modal_header_ {
            color: #edeeef;
            .close {
                color: #edeeef;
                opacity: 1;
            }
        }
        #bulk-modal___BV_modal_body_ {
            .select-actions {
                .btn-link {
                    color: #edeeef;
                    &.active {
                        color: #0088ff;
                    }
                }
            }
            .dnd-area {
                border-color: #edeeef;
                .text {
                    h3 {
                        color: #edeeef;
                    }
                }
            }

            .migrate-plan,
            .sim-swap-header {
                color: #ffffff;
            }

            .sims-list-wrapper {
                .row {
                    .form-control {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #EDEEEF;
                        &::placeholder {
                            color: #ffffff;
                        }
                    }
                    .text-right {
                        color: #edeeef;
                    }
                }
            }
            .bottom-table {
                .selected-sim {
                    color: #edeeef;
                }
            }
        }
    }

    #bulk-modal {
        .modal-dialog {
            .modal-content {
                .migrate-plan {
                    h3 {
                        color: #ffffff;
                    }
                }
            }
        }
    }
    #select-from-plan,
    #select-to-plan {
        .modal-header {
            .close {
                color: #ffffff;
                opacity: 1;
            }
        }
        .modal-dialog {
            .modal-content {
                background-color: #3a4149;
                color: #ffffff;
                .modal-header {
                    .rate-plan-name {
                        color: #ffffff;
                    }
                }
            }
        }
    }

    .inner-migrate {
        .header-plan {
            .title {
                .category {
                    em {
                        color: #ffffff;
                    }
                }
            }
        }
        .body-plan {
            .list-options {
                .item-options {
                    &.false {
                        em {
                            color: white;
                        }
                    }
                }
            }
        }
    }
}

.sims-list-wrapper {
    &.fts-table-wrapper {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }
}

</style>
